import { render } from "./PreviewLesson.vue?vue&type=template&id=1a5e6076&ts=true"
import script from "./PreviewLesson.vue?vue&type=script&lang=ts"
export * from "./PreviewLesson.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__